import FetchClients, { ClientOutput } from "../client";
import { useQuery as useReactQuery } from "@tanstack/react-query";
import { recursiveCamelCaseCipherTypesafe } from "@src/global_functions/postgrestApi";
import { CamelCasedProperties } from "type-fest";

const connectedAccounts = {
  useGetConnectedEnergyStarAccounts,
} as const;
export default connectedAccounts;

export type ConnectedEnergyStarAccounts = CamelCasedProperties<
  ClientOutput["site"]["EnergyStarConnectedAccountAgg"]
>;

const getConnectedEnergyStarAccounts = async (siteId: number) => {
  const { data, error } = await FetchClients.site.GET(
    "/{site_id}/connected_es_accounts",
    {
      params: {
        path: {
          site_id: siteId,
        },
      },
    }
  );
  if (data) return recursiveCamelCaseCipherTypesafe(data);
  throw new Error(error);
};

function useGetConnectedEnergyStarAccounts(siteId: number) {
  return useReactQuery({
    queryKey: ["connected-es-acccounts", siteId],
    queryFn: () => getConnectedEnergyStarAccounts(siteId),
  });
}
